module.exports = __webpack_public_path__ + "static/media/Believers.c865e389.svg";